import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import UI from 'editor-ui-lib';
import Wix from 'Wix';

import Picker from '../../../../components/picker/Picker';
import ToggleSwitch from './toggleSwitch';
import { onOpenModalPicker, onOpenModalEdit, onOpenModalWait } from '../helperFunction';
//actions
import setDataPublic from '../../../../../actions/dataPublicActions';
import { setDisplayLastModified, setDisplayOwner, setSortDefault } from '../../../../../actions/updateConnectActions';
//api
import { getFileByFileId } from '../../../../../widget/api/GoogleDriveApi';
import { updateFilePermission, checkIfFileEditable } from '../../../../../widget/api/PermissionsAPI';
import parameters from "../../../../../config/parameters";


//style
import './settings.scss';


class Settings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fileName: '',
            toggleDisabled: false,
            sort: {
                owner: true,
                date: true
            }

        }
        this.compId = Wix.Utils.getOrigCompId();
        this.changeRoleFile = this.changeRoleFile.bind(this);
        this.toggleRoleFile = this.toggleRoleFile.bind(this);
        this.renderTitle = this.renderTitle.bind(this);
        this.toggleLabel = <FormattedMessage id={'settings.display.displayTitle'} />;
    }
    componentWillReceiveProps(newProps) {
        if (newProps.dataPublic && newProps.dataPublic.activeFileId) {
            getFileByFileId(newProps.dataPublic.activeFileId,newProps.dataPublic.resourceKey,  (file) => {
                if (file) {
                    checkIfFileEditable(newProps.dataPublic.activeFileId, (e) => {
                        this.setState({ file: file, fileName: file.title, editable: e })
                    })
                }
            }, true)
        }
    }

    OpenModalEdit(toggle) {
        let titltPopupEdit = this.props.intl.formatMessage({ id: 'settings.popup.allowEditing' });
        onOpenModalEdit(!this.state.file.mimeType.includes('folder'), titltPopupEdit, (editFolder) => {
            if (editFolder) {
                toggle.checked = true;
                this.setState({ toggleDisabled: false });
                this.changeRoleFile(true);

            } else {
                this.setState({ toggleDisabled: false, editable: false });
                toggle.checked = false;
            }
        })
    }
    EditableFiles() {
        return this.state.file && (this.state.file.mimeType.includes('google') && !this.state.file.mimeType.includes('form') && !this.state.file.mimeType.includes('folder')
        )
    }
    toggleRoleFile(toggle) {
        this.setState({ toggle1: toggle });
        if (toggle.checked === true) {
            toggle.checked = false;
            this.setState({ toggleDisabled: true });
            if (this.props.dataPublic.userName !== this.state.file.owners[0].displayName) {
                checkIfFileEditable(this.state.file.id, (e) => {
                    if (!e) {
                        onOpenModalWait(!this.state.file.mimeType.includes('folder'), this.props.intl.formatMessage({ id: 'settings.popup.noPermission' }), () => this.setState({ toggleDisabled: false }));
                    }
                    else {
                        this.OpenModalEdit(toggle);
                    }
                })
            }
            else {
                this.OpenModalEdit(toggle);
            }
        }
        else {
            this.changeRoleFile(toggle.checked);
        }
    }

    changeRoleFile(canEdit) {
        let fileId = this.state.file.id;
        updateFilePermission(fileId, canEdit ? 'writer' : 'reader', (resp) => {
            if (resp.id) {
                const datapublicObj = { "compId": this.compId, "editable": canEdit, "isSignleFile": true };
                this.props.setDataPublic(datapublicObj);
                const data = { key: 'canEdit', value: { compId: this.compId, canEdit: canEdit } };
                Wix.Settings.triggerSettingsUpdatedEvent(data, this.compId);
                this.setState({ editable: canEdit })
            }
        });
    }

    renderTitle(text) {
        return (
            <div>
                <hr className="divider-long" />
                <UI.sectionDividerLabeled label={text} />
                <hr className="divider-long" />
            </div>
        )
    }

    renderFileOrFolderSettings() {
        return (
            <div>
                {this.renderTitle(this.props.intl.formatMessage({ id: 'settings.settings.title' }))}
                <div className='To-select-a-file-or You-are-now-connecte'>
                    <div>
                        {this.props.intl.formatMessage({ id: 'settings.settings.nowConnect' })}&nbsp;
                        <UI.button
                            label={this.props.intl.formatMessage({ id: 'settings.settings.link.select' })}
                            className="btn-upgrade-link"
                            onClick={() => onOpenModalPicker(this)}>
                        </UI.button>
                        {this.props.intl.formatMessage({ id: 'settings.settings.toDisplay' })}
                    </div>
                </div>
            </div>
        )
    }

    renderManageFileorFolder() {
        return (
            <div>
                {this.renderTitle(this.props.intl.formatMessage({ id: 'settings.settings.manageTitle' }))}
                <div className='To-select-a-file-or'>
                    {this.props.intl.formatMessage({ id: 'settings.settings.selectDescription' })}&nbsp;
                    <div style={{ display: "inline-flex" }}>
                        <Picker
                            connect={true}
                            children={
                                <UI.button
                                    label={this.props.intl.formatMessage({ id: 'settings.connectAccount' })}
                                    className="btn-upgrade-link"
                                    onClick={() => this.props.connectBI("Settings", "connect account")}>
                                </UI.button>
                            }
                        />
                    </div>
                </div>
            </div>
        )
    }
    renderSortDropDown() {
        let options;
        if (this.props.displayOwner !== false && this.props.displayLastModified !== false) {
            options =
                [{ value: "1", label: this.props.intl.formatMessage({ id: 'settings.settings.lastModified' }) },
                { value: "2", label: this.props.intl.formatMessage({ id: 'settings.settings.name' }) },
                { value: "3", label: this.props.intl.formatMessage({ id: 'settings.settings.owner' }) }]
        }
        else if (this.props.displayLastModified === false && this.props.displayOwner !== false) {
            options =
                [{ value: "2", label: this.props.intl.formatMessage({ id: 'settings.settings.name' }) },
                { value: "3", label: this.props.intl.formatMessage({ id: 'settings.settings.owner' }) }]
        }
        else if (this.props.displayOwner === false && this.props.displayLastModified !== false) {
            options =
                [{ value: "1", label: this.props.intl.formatMessage({ id: 'settings.settings.lastModified' }) },
                { value: "2", label: this.props.intl.formatMessage({ id: 'settings.settings.name' }) }]
        }
        else {
            options = [{ value: "2", label: { value: "2", label: this.props.intl.formatMessage({ id: 'settings.settings.name' }) } }];
        }
        if (options.length > 1)
            return (
                <div className="wrapperSortSelect">
                    <UI.dropDownSelect
                        defaultValue={this.props.sortDefault}
                        onChange={(newVal) => this.props.setSortDefault(newVal)}
                        title={this.props.intl.formatMessage({ id: 'settings.settings.SelectDefaultSort' })}
                        wix-param="select_sort"
                        options={options} />
                </div>
            )

    }

    renderCheckboxs() {
        return (
            <div className="wrapperCheckbox">
                <div className="Label-for-checkboxes">{this.props.intl.formatMessage({ id: 'settings.settings.DisplayFileInfo' })}</div>
                <UI.checkbox
                    label={this.props.intl.formatMessage({ id: 'settings.settings.fileTypeIcon' })}
                    defaultValue={true}
                    wix-param='displayIcon'
                    onChange={newVal => console.log("newVal", newVal)}
                />
                <UI.checkbox
                    label={this.props.intl.formatMessage({ id: 'settings.settings.ownerName' })}
                    defaultValue={true}
                    wix-param='displayOwner'
                    onChange={newVal => {
                        this.props.setDisplayOwner(newVal)
                        if (this.props.sortDefault == "3" && newVal == false) {
                            this.props.setSortDefault("2")
                            Wix.Styles.setNumberParam('select_sort', { value: "2" });
                        }
                    }}
                />
                <UI.checkbox
                    label={this.props.intl.formatMessage({ id: 'settings.settings.lastModified' })}
                    defaultValue={true}
                    wix-param='displayLastModified'
                    onChange={newVal => {
                        this.props.setDisplayLastModified(newVal)
                        if (this.props.sortDefault == "1" && newVal == false) {
                            this.props.setSortDefault("2")
                            Wix.Styles.setNumberParam('select_sort', { value: "2" });
                        }
                    }
                    }
                />
                {/* <hr className="divider-long"/> */}
            </div>
        );
    }

    renderFolderSettingsLayout() {
        if (this.state.file.mimeType.includes('folder'))
            return (
                <div>
                    <hr className="divider-short" />
                    {this.renderCheckboxs()}
                    <hr className="divider-long" />
                    {this.renderSortDropDown()}
                    <hr className="divider-long" />
                    <UI.toggleSwitch
                        label={this.props.intl.formatMessage({ id: 'settings.settings.EnableSearch' })}
                        defaultValue={true}
                        wix-param={'displaySearchBar'} />
                </div>
            )
    }

    renderFileSettings() {
        if (!this.state.file) return;
        let status = 'file';
        let selectText = this.props.intl.formatMessage({ id: 'settings.settings.SelectedFile' });
        let editableTitle = this.props.intl.formatMessage({ id: 'settings.settings.allowEditing' });
        let editableDescription = this.props.intl.formatMessage({ id: 'settings.settings.allowEditingDescription' });
        let settingsText = this.props.intl.formatMessage({ id: 'settings.settings.fileTitle' });
        if (this.state.file.mimeType.includes('folder')) {
            status = 'folder';
            selectText = this.props.intl.formatMessage({ id: 'settings.settings.SelectedFolder' })
            editableDescription = this.props.intl.formatMessage({ id: 'settings.settings.allowEditingFolderDescription' });
            settingsText = this.props.intl.formatMessage({ id: 'settings.settings.folderTitle' });
        }
        let editableText = this.props.intl.formatMessage({ id: 'settings.settings.allowEditing' });
        const locale =  Wix.Utils.getLocale()||'en';
        let linkLearnMore = `https://support.wix.com/${locale}/article/allowing-or-blocking-the-editing-of-a-google-drive-file-or-folder`
       return (
            <div>
                {this.renderTitle(settingsText)}
                <div className='To-select-a-file-or selected-file'>
                    <div className='label'>{selectText}</div>
                    <div className='title-file'>
                        <div className='Choose-Link'>
                            {this.state.fileName.length > 29 ?
                                <UI.tooltip width="240px" value={this.state.fileName}>
                                    {this.state.fileName.substr(0, 18) + "..."}
                                </UI.tooltip>
                                : this.state.fileName}
                        </div>
                        <UI.tooltip value={this.props.intl.formatMessage({ id: 'settings.settings.replace' })}>
                            <UI.button
                                className="btn-sm"
                                onClick={() => onOpenModalPicker(this)}
                                icon="image-change">
                            </UI.button>
                        </UI.tooltip>
                    </div>
                </div>
                {this.EditableFiles() ?
                    <div>
                        <hr className="divider-long" />
                        <ToggleSwitch
                            defaultValue={this.state.editable}
                            title={editableText}
                            callback={this.toggleRoleFile}
                            disabled={this.state.toggleDisabled}
                        />
                        <hr className="divider-short" />
                        <div className='To-select-a-file-or selected-file'>
                            <div className='label'>
                            {editableTitle}
                            </div>
                            <div className='editable'>
                            <div> {editableDescription}</div>
                                <UI.button
                                    label={<FormattedMessage id="settings.link.learnMore" />}
                                    className="btn-upgrade-link"
                                    onClick={() => { window.open(linkLearnMore) }}>
                                </UI.button>
                            </div>
                        </div>
                    </div>
                    : null}
                {this.renderFolderSettingsLayout()}
            </div>
        )
    }
    render() {
        const isErrorConnectStatus = this.props.showError || (this.props.dataPublic && this.props.dataPublic.scope && (!this.props.dataPublic.scope.includes('https://www.googleapis.com/auth/drive'))) ;   

        return (
            <div className="main-tab">
                {
                    this.props.showBtn || (this.props.dataPublic && typeof this.props.dataPublic.userName !== 'undefined' && this.props.dataPublic.userName !== null && this.props.dataPublic.userName !== '' && !isErrorConnectStatus) ?
                        this.props.dataPublic.activeFileId && this.props.dataPublic.activeFileId !== parameters['DEFAULT_FILE']  ?
                            this.renderFileSettings() : this.renderFileOrFolderSettings()
                        : this.renderManageFileorFolder()
                }
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    setDataPublic: (dataPublic) => dispatch(setDataPublic(dataPublic)),
    setDisplayLastModified: (displayLastModified) => dispatch(setDisplayLastModified(displayLastModified)),
    setDisplayOwner: (displayOwner) => dispatch(setDisplayOwner(displayOwner)),
    setSortDefault: (sortDefault) => dispatch(setSortDefault(sortDefault))
});

const mapStateToProps = state => ({
    dataPublic: state.dataPublicReducer.dataPublic,
    showError: state.userConnectReducer.showError,
    displayLastModified: state.userConnectReducer.displayLastModified,
    displayOwner: state.userConnectReducer.displayOwner,
    sortDefault: state.userConnectReducer.sortDefault
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Settings));



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/settings/settings.js